module.exports = __webpack_public_path__ + "static/BFB_FoundryIntro_OOH-dc591a034fe8af4c791a64aa6d23c58e.jpg";